import React from 'react';
import { GridContainer, CenterContent } from 'global/components/perform-grid';
import Table from './table';

export default (props) => {
  return (
    <GridContainer>
      <CenterContent fullWidth>
        <Table {...props} />
      </CenterContent>
    </GridContainer>
  );
};
